import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { UserService, BaseComponent, Video, Lesson, ContentService, environment, HelperService, Tag } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { ClipboardService } from "ngx-clipboard";
import { FuiContentFilterComponent } from "../fender-ui/content-filter/content-filter.component";
import { Location } from "@angular/common";

@Component({
  selector: "fui-filterable-video-group",
  templateUrl: "filterable-video-group.component.html",
  standalone: false,
})
export class FilterableVideoGroupComponent extends BaseComponent {
  @Input() videos: Array<Video>;
  @Input() ignoreBrand: boolean = false;
  @Input() title: string;
  @Input() description: string;
  @Input() image: string;
  @Input() showFilterOptions: boolean = true;
  @Input() educationData: any;
  public filters: any = {
    sort_by: "date",
    sort_order: "desc",
    product: "any",
    tag: "any",
    duration: "any",
    level: "any",
    query: "",
  };
  public page: number = 0;
  public limit: number = 20;
  public totalPages: number;
  public totalVideos: number;
  public displayedVideos: Array<Video>;
  public filteredVideos: Array<Video>;
  public displayedTag: any;
  public availableTags: Array<Tag> = [];

  @Output() goBackClicked: EventEmitter<void> = new EventEmitter();
  @Output() hideFiltersClicked: EventEmitter<void> = new EventEmitter();
  @ViewChild("sidebarFilterModal") sidebarFilterModal: any;

  constructor(
    userService: UserService,
    public contentService: ContentService,
    public appService: AppService,
    public helperService: HelperService,
    public location: Location,
    private _clipboardService: ClipboardService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.availableTags = [...this.contentService.tagsAssociatedWithVideos];
    this.filter();
  }

  closeFilterOptions() {
    this.showFilterOptions = false;
  }

  videoContentTypeChanged() {
    this.filter();
  }

  chooseTag(tag) {
    this.displayedTag = tag;
    this.filters.tag = tag.id;
    this.filter();
    this.location.replaceState("learn/videos?tag=" + this.displayedTag.string_id);
  }

  chooseProduct(product) {
    this.filters.product = product.id;
    this.filter();
    this.location.replaceState("learn/videos?product=" + product.stringId);
  }

  paginate(direction) {
    this.page = this.page + (direction == "next" ? 1 : -1);
    this.displayedVideos = [
      ...this.filteredVideos.filter((item, index) => {
        return index >= this.page * this.limit && index < this.page * this.limit + this.limit;
      }),
    ];
    this.totalPages = Math.floor(this.filteredVideos.length / this.limit);
    this.totalVideos = this.filteredVideos.length;
  }

  public showMobileFilters() {
    this.appService.showModal(this.sidebarFilterModal, { size: "lg" });
  }

  filter(query?: string) {
    this.filters.query = query;
    this.page = 0;
    this.filteredVideos = this.videos;
    if (this.appService.sortBy == "date") {
      this.filteredVideos.sort((a, b) => {
        return a.created > b.created ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1;
      });
      this.educationData.videos.sort((a, b) => {
        return a.created > b.created ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1;
      });
    } else if (this.appService.sortBy == "abc") {
      this.filteredVideos.sort((a, b) => {
        return a.title > b.title ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1;
      });
      this.educationData.videos.sort((a, b) => {
        return a.title > b.title ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1;
      });
    }
    if (this.filters.query) {
      let videos = this.videos;
      if (
        this.ignoreBrand ||
        (this.appService.videoContentType.fender && this.appService.videoContentType.presonus) ||
        (!this.appService.videoContentType.fender && !this.appService.videoContentType.presonus)
      ) {
        this.filteredVideos = videos.filter((item) => item.title.toLowerCase().indexOf(this.filters.query.toLowerCase()) > -1);
      } else {
        if (this.appService.videoContentType.presonus) {
          this.filteredVideos = videos.filter((item) => item.title.toLowerCase().indexOf(this.filters.query.toLowerCase()) > -1 && (item.brand == "presonus" || item.brand == "both"));
        } else {
          this.filteredVideos = videos.filter((item) => item.title.toLowerCase().indexOf(this.filters.query.toLowerCase()) > -1 && (item.brand == "fender" || item.brand == "both"));
        }
      }
    } else {
      if (this.filters.product != "any") {
        this.filteredVideos = [
          ...this.filteredVideos.filter((item) => {
            return item.products.filter((prod) => prod.id == this.filters.product).length;
          }),
        ];
      }
      if (this.filters.tag != "any") {
        this.filteredVideos = [
          ...this.filteredVideos.filter((item) => {
            return item.tags.filter((tag) => tag.id == this.filters.tag).length;
          }),
        ];
        let sidebarTag = this.contentService.sidebarTags.filter((item) => item.id == this.filters.tag)[0];
        if (sidebarTag) {
          this.displayedTag = sidebarTag;
          // this.displayedFolder = undefined;
        } else {
          this.displayedTag = undefined;
          // this.displayedFolder = {
          //   title: "All Videos",
          // };
        }
      } else if (this.filters.tag == "any") {
        this.displayedTag = undefined;
      }
      if (this.filters.duration != "any") {
        let parts = this.filters.duration.split("_");
        this.filteredVideos = [...this.filteredVideos.filter((item) => item.duration >= parseInt(parts[0]) && item.duration < parseInt(parts[1]))];
      }
      if (this.filters.level != "any") {
        this.filteredVideos = [...this.filteredVideos.filter((item) => item.level == (this.filters.level == "none" ? null : this.filters.level))];
      }
      if (
        this.ignoreBrand ||
        (this.appService.videoContentType.fender && this.appService.videoContentType.presonus) ||
        (!this.appService.videoContentType.fender && !this.appService.videoContentType.presonus)
      ) {
      } else {
        const selectedBrand = this.appService.videoContentType.fender ? "fender" : "presonus";
        this.filteredVideos = [...this.filteredVideos.filter((item) => item.brand == selectedBrand || item.brand == "both")];
      }
    }
    this.displayedVideos = [...this.filteredVideos.filter((item, index) => index <= this.limit - 1)];
    this.totalPages = Math.floor(this.filteredVideos.length / this.limit);
    this.totalVideos = this.filteredVideos.length;
  }

  resetFilters() {
    this.filters = {
      platform: "any",
      status: "any",
      sort_by: "date",
      sort_order: "desc",
      product: "any",
      tag: "any",
      duration: "any",
      level: "any",
      query: "",
    };
    this.filter();
  }

  clearFilter(filter?) {
    if (filter == "product") {
      this.filters.product = "any";
    } else if (filter == "tag") {
      this.filters.tag = "any";
    } else if (filter == "duration") {
      this.filters.duration = "any";
    } else if (filter == "level") {
      this.filters.level = "any";
    } else if (!filter) {
      this.filters.query = "";
      this.filters.product = "any";
      this.filters.tag = "any";
      this.filters.duration = "any";
      this.filters.level = "any";
    }
  }
}
